import { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Box, Typography } from "@mui/material";
import QuoteForm from "../../QuoteForm/QuoteForm";
import { AuthContext } from "../../../../../context/AuthContext";
import { SnackAlertContext } from "../../../../../context/SnackAlertContext";

const EditQuotePage = () => {
  const { quoteId } = useParams();
  const { openSnackMessage } = useContext(SnackAlertContext);
  const { ezorder, authToken } = useContext(AuthContext);
  const [loading, setLoading] = useState();
  const navigate = useNavigate();

  const updateQuote = async (quote) => {
    try {
      setLoading(true);
      let response = await ezorder.put(
        `/admin/orders/${quoteId}`,
        { ...quote },
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }
      );

      console.log(response.data.order);
      if (response.status == 200 || response.status === 201) {
        openSnackMessage("success", "Quote Saved!");
        navigate(`/quotes/${response.data.order.id}`);
      }
    } catch (error) {
      console.log(error);
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);
        openSnackMessage("error", error.response.data.error);
      } else {
        // Something went really bad
        console.log(error);
        openSnackMessage("error", error);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box>
      {/* TODO: Editable Quote Form */}
      {/* Pass in (quoteId: number|null) to load quote data or start with an empty quote object if creating a new one */}
      {/* QuoteForm in this page will always have a quoteId */}
      <Typography variant="h4" textAlign="center">
        Edit Quote
      </Typography>
      <QuoteForm
        quoteId={quoteId}
        onSave={(quote) => {
          updateQuote(quote);
        }}
        saveButtonTitle="Update Quote"
        saving={loading}
      />
    </Box>
  );
};

export default EditQuotePage;
